import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum IntegrationPartnerTypeId {
  POS = 1,
  ACCOUNTING = 2,
  RMS = 3,
  LOCK_SYSTEM = 4,
  ECONOMIC_SYSTEM = 5,
  PARKING = 6,
  HOUSEKEEPING = 7,
  BOOKING_ENGINE = 8,
  CHANNEL_MANAGER = 9,
  SMART_HOTEL = 10,
  GENERIC_API = 11,
  ID_READER = 12,
  CRM = 13,
  COMMUNICATION = 14,
  PMS = 15,
  OTHER = 99,
}

export class IntegrationPartnerType extends Codebook<IntegrationPartnerTypeId> {
  static readonly POS = new IntegrationPartnerType(IntegrationPartnerTypeId.POS, () => $t('POS'))

  static readonly ACCOUNTING = new IntegrationPartnerType(IntegrationPartnerTypeId.ACCOUNTING, () =>
    $t('Accounting'),
  )

  static readonly RMS = new IntegrationPartnerType(IntegrationPartnerTypeId.RMS, () => $t('RMS'))

  static readonly LOCK_SYSTEM = new IntegrationPartnerType(
    IntegrationPartnerTypeId.LOCK_SYSTEM,
    () => $t('Lock system'),
  )

  static readonly ECONOMIC_SYSTEM = new IntegrationPartnerType(
    IntegrationPartnerTypeId.ECONOMIC_SYSTEM,
    () => $t('Economic system'),
  )

  static readonly PARKING = new IntegrationPartnerType(IntegrationPartnerTypeId.PARKING, () =>
    $t('Parking'),
  )

  static readonly HOUSEKEEPING = new IntegrationPartnerType(
    IntegrationPartnerTypeId.HOUSEKEEPING,
    () => $t('Housekeeping'),
  )

  static readonly BOOKING_ENGINE = new IntegrationPartnerType(
    IntegrationPartnerTypeId.BOOKING_ENGINE,
    () => $t('Booking engine'),
  )

  static readonly CHANNEL_MANAGER = new IntegrationPartnerType(
    IntegrationPartnerTypeId.CHANNEL_MANAGER,
    () => $t('Channel manager'),
  )

  static readonly SMART_HOTEL = new IntegrationPartnerType(
    IntegrationPartnerTypeId.SMART_HOTEL,
    () => $t('Smart hotel'),
  )

  static readonly GENERIC_API = new IntegrationPartnerType(
    IntegrationPartnerTypeId.GENERIC_API,
    () => $t('Generic API'),
  )

  static readonly ID_READER = new IntegrationPartnerType(IntegrationPartnerTypeId.ID_READER, () =>
    $t('ID reader'),
  )

  static readonly CRM = new IntegrationPartnerType(IntegrationPartnerTypeId.CRM, () => $t('CRM'))

  static readonly COMMUNICATION = new IntegrationPartnerType(
    IntegrationPartnerTypeId.COMMUNICATION,
    () => $t('Communication'),
  )

  static readonly PMS = new IntegrationPartnerType(IntegrationPartnerTypeId.PMS, () => $t('PMS'))

  static readonly OTHER = new IntegrationPartnerType(IntegrationPartnerTypeId.OTHER, () =>
    $t('Other'),
  )

  private constructor(
    id: IntegrationPartnerTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
